import { Multiselect } from "multiselect-react-dropdown";
import React, { Component } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import "../../assets/styles/DiscountCoupons.css";
import { sess_get, sess_post } from "../../utils/HttpRequests";

class DicountCouponListComponent extends Component {
  constructor() {
    super();
    this.state = {
      data: {
        code: "DO*****",
        startDate: "",
        expiryDate: "",
        flat: 0,
        percentage: 0,
        percentageCap: 0,
        numbers: null,
        type: "flat",
        plans: new Set(),
        selectedValues: [],
        user_type: "all_users",
      },
      plans: [],
      error: {
        code: "",
        numbers: "",
      },
      isSubmitting: false,
      hasErrors: false,
    };
  }

  async componentDidMount() {
    const session_token = localStorage.getItem("admin-panel-sessionToken");
    let plans = await sess_get("admin/console/get-plans", session_token);
    if (
      plans &&
      plans.data &&
      plans.data.response &&
      plans.data.response.plans
    ) {
      plans = plans.data.response.plans;
    } else {
      plans = [];
    }
    this.setState({
      plans,
    });
  }

  hasErrors() {
    let { error } = this.state;
    if (error.code) {
      return true;
    }
    if (error && Array.isArray(error.numbers)) {
      for (let e of error.numbers) if (e) return true;
    }
    return false;
  }

  setErrorStatus() {
    let hasErrors = this.hasErrors();
    this.setState({
      ...this.state,
      hasErrors,
    });
  }

  handleCodeChange = async (event) => {
    let code = event.target.value.toUpperCase();
    let codeError = "";
    if (code.length < 6 || code.length > 20) {
      codeError = "Code Length must be between 6 and 30 characters long";
    } else {
      codeError = "";
    }
    this.setState(
      {
        ...this.state,
        data: {
          ...this.state.data,
          code,
        },
        error: {
          ...this.state.error,
          code: codeError,
        },
      },
      this.setErrorStatus
    );
  };

  handleStartDateChange = async (event) => {
    let startDate = event.target.value;
    this.setState({
      ...this.state,
      data: {
        ...this.state.data,
        startDate,
      },
    });
  };

  handleExpiryDateChange = async (event) => {
    this.setState({
      ...this.state,
      data: {
        ...this.state.data,
        expiryDate: event.target.value,
      },
    });
  };

  handleUserType = async (event) => {
    let user_type = event.target.value;
    let state = {
      ...this.state,
      data: {
        ...this.state.data,
        user_type,
      },
    };
    this.setState(state);
  };

  handleDicountType = async (event) => {
    let type = event.target.value;
    let state = {
      ...this.state,
      data: {
        ...this.state.data,
        type,
      },
    };
    if (type == "flat") {
      state.data.percentage = 0;
      state.data.percentageCap = 0;
    } else if (type == "percentage") {
      state.data.flat = 0;
    }
    this.setState(state);
  };

  handleFlatChange = async (event) => {
    let flat = event.target.value;
    if (flat < 0) flat = 0;
    this.setState({
      ...this.state,
      data: {
        ...this.state.data,
        flat,
      },
    });
  };

  handlePercentageChange = async (event) => {
    let percentage = event.target.value;
    if (percentage < 0) {
      percentage = 0;
    } else if (percentage > 100) {
      percentage = 100;
    }
    this.setState({
      ...this.state,
      data: {
        ...this.state.data,
        percentage,
      },
    });
  };

  handlePercentageCapChange = async (event) => {
    let percentageCap = event.target.value;
    if (percentageCap < 0) {
      percentageCap = 0;
    }
    this.setState({
      ...this.state,
      data: {
        ...this.state.data,
        percentageCap,
      },
    });
  };

  handlePhoneNumbersStatusChange = async (event) => {
    let numbers = event.target.checked ? [""] : null;
    let numbersError = event.target.checked
      ? ["phone numbers must be 10 digit long"]
      : "";
    this.setState(
      {
        ...this.state,
        data: {
          ...this.state.data,
          numbers,
        },
        error: {
          ...this.state.error,
          numbers: numbersError,
        },
      },
      this.setErrorStatus
    );
  };

  handleChangeNumbers = (i) => {
    return async (event) => {
      let number = event.target.value;
      let numbers = [...this.state.data.numbers];
      let numbersError = [...this.state.error.numbers];
      numbers[i] = number;
      if (number.length != 10) {
        numbersError[i] = "phone numbers must be 10 digit long";
      } else {
        let hasDuplicate = false;
        for (let j = 0; j < numbers.length; j++) {
          if (i == j) continue;
          if (numbers[j] == number) {
            hasDuplicate = true;
            break;
          }
        }
        if (!hasDuplicate) {
          numbersError[i] = "";
        } else {
          numbersError[i] = "Phone Number cannot be duplicate";
          return this.setState(
            {
              ...this.state,
              error: {
                ...this.state.error,
                numbers: numbersError,
              },
            },
            this.setErrorStatus
          );
        }
      }
      this.setState(
        {
          ...this.state,
          data: {
            ...this.state.data,
            numbers,
          },
          error: {
            ...this.state.error,
            numbers: numbersError,
          },
        },
        this.setErrorStatus
      );
    };
  };

  deleteNumber = (i) => {
    return async () => {
      let numbers = [...this.state.data.numbers];
      numbers.splice(i, 1);
      let numbersError = [...this.state.error.numbers];
      numbersError.splice(i, 1);
      this.setState(
        {
          ...this.state,
          data: {
            ...this.state.data,
            numbers,
          },
          error: {
            ...this.state.error,
            numbers: numbersError,
          },
        },
        this.setErrorStatus
      );
    };
  };

  addNumber = () => {
    let numbers = [...this.state.data.numbers, ""];
    let numbersError = [
      ...this.state.error.numbers,
      "phone numbers must be 10 digit long",
    ];
    this.setState(
      {
        ...this.state,
        data: {
          ...this.state.data,
          numbers,
        },
        error: {
          ...this.state.error,
          numbers: numbersError,
        },
      },
      this.setErrorStatus
    );
  };

  handleLimitChange = async (event) => {
    let limit = event.target.value;
    if (limit < 0) {
      limit = 0;
    }
    this.setState({
      ...this.state,
      data: {
        ...this.state.data,
        limit,
      },
    });
  };

  handleActiveChange = async (event) => {
    let active = event.target.checked;
    this.setState({
      ...this.state,
      data: {
        ...this.state.data,
        active,
      },
    });
  };

  handleCarePortalEnabledChange = async (event) => {
    let care_portal_enabled = event.target.checked;
    this.setState({
      ...this.state,
      data: {
        ...this.state.data,
        care_portal_enabled,
      },
    });
  };

  handleVisibleOnAndroid = async (e) => {
    let visible_on_android = e.target.checked;
    this.setState({
      ...this.state,
      data: {
        ...this.state.data,
        visible_on_android,
      },
    });
  }


  handleCustomerDelight = async (e) => {
    let customer_delight = e.target.checked;
    this.setState({
      ...this.state,
      data: {
        ...this.state.data,
        customer_delight,
      },
    });
  }

  handleAndroidRenewal = async (e) => {
    let android_renewal = e.target.checked;
    this.setState({
      ...this.state,
      data: {
        ...this.state.data,
        android_renewal,
      },
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({
      ...this.state,
      isSubmitting: true,
    });
    this.submitDiscountCoupon().then((d) => {
      if (d && d.error) {
        this.setState({
          ...this.state,
          isSubmitting: false,
        });
        toast.error("We were unable to add the coupon", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      } else {
        this.props.history.push("/discount-coupon");
        toast.success("Coupon Added!", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    });
  };

  submitDiscountCoupon = async () => {
    const session_token = localStorage.getItem("admin-panel-sessionToken");
    let data = this.state.data;
    data.plans = [...this.state.data.plans];
    if (!data.plans || !data.plans.length) {
      data.plans = null;
    }
    return sess_post("admin/console/discount-coupon", session_token, data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        console.error(err);
        return { error: err.toString() };
      });
  };

  onSelect = (selectedList, selectedItem) => {
    let id = selectedItem.plan_id;
    let plans = this.state.data.plans;
    plans.add(id);
    this.setState({
      data: {
        ...this.state.data,
        plans,
      },
    });
  };

  onRemove = (selectedList, removedItem) => {
    let id = removedItem.plan_id;
    let plans = this.state.data.plans;
    plans.delete(id);
    this.setState({
      data: {
        ...this.state.data,
        plans,
      },
    });
  };

  render() {
    let { data, isSubmitting, error, hasErrors, plans } = this.state;
    return (
      <div className="discount-container">
        <div className="header">
          <div>Add Discount Coupons</div>
          {/* <button onClick={this.redirectToCoupon('new')}>+</button> */}
        </div>
        <Form onSubmit={this.handleSubmit} className="form-container">
          <Form.Group controlId="code">
            <Form.Label>Code</Form.Label>
            <Form.Control
              onChange={this.handleCodeChange}
              value={data.code}
              type="text"
            />
            <Form.Text className={"error-label"}>{error.code}</Form.Text>
          </Form.Group>
          <Form.Group controlId="startDate">
            <Form.Label>Start Date</Form.Label>
            <Form.Control
              onChange={this.handleStartDateChange}
              value={data.startDate}
              type="date"
            />
          </Form.Group>
          <Form.Group controlId="expiryDate">
            <Form.Label>Expiry Date</Form.Label>
            <Form.Control
              onChange={this.handleExpiryDateChange}
              value={data.expiryDate}
              type="date"
            />
          </Form.Group>
          <Form.Group controlId="expiryDate">
            <Form.Label>Plans</Form.Label>
            <Multiselect
              options={plans}
              displayValue="plan_type"
              selectedValues={data.selectedValues}
              onSelect={this.onSelect}
              onRemove={this.onRemove}
            />
          </Form.Group>
          <Form.Group controlId="user_type">
            <Form.Label>User Type</Form.Label>
            <div key={`inline-radio`} className="mb-3">
              <Form.Check
                inline
                name="user_type"
                checked={data.user_type == "all_users"}
                onChange={this.handleUserType}
                value="all_users"
                label="All"
                type="radio"
                id="all_radio"
              />
              <Form.Check
                inline
                name="user_type"
                checked={data.user_type == "new_users"}
                onChange={this.handleUserType}
                value="new_users"
                label="New Users"
                type="radio"
                id="new_radio"
              />
              <Form.Check
                inline
                name="user_type"
                checked={data.user_type == "existing_users"}
                onChange={this.handleUserType}
                value="existing_users"
                label="Existing Users"
                type="radio"
                id="existing_radio"
              />
            </div>
          </Form.Group>
          <fieldset className="dicount_value_box">
            <legend>Discount Type:</legend>
            <div key={`inline-radio`} className="mb-3">
              <Form.Check
                inline
                name="radio"
                checked={data.type == "flat"}
                onChange={this.handleDicountType}
                value="flat"
                label="Flat"
                type="radio"
                id="flat_radio"
              />
              <Form.Check
                inline
                name="radio"
                checked={data.type == "percentage"}
                onChange={this.handleDicountType}
                value="percentage"
                label="Percentage"
                type="radio"
                id="percentage_radio"
              />
            </div>
            {data.type == "flat" && (
              <Form.Group controlId="flat">
                <Form.Label>Flat Discount(Rs)</Form.Label>
                <Form.Control
                  onChange={this.handleFlatChange}
                  value={data.flat}
                  type="number"
                />
              </Form.Group>
            )}
            {data.type == "percentage" && (
              <>
                <Form.Group controlId="percentage">
                  <Form.Label>Percentage Discount(%)</Form.Label>
                  <Form.Control
                    onChange={this.handlePercentageChange}
                    value={data.percentage}
                    type="number"
                  />
                </Form.Group>
                <Form.Group controlId="percentageCap">
                  <Form.Label>Percentage Discount Cap(Rs)</Form.Label>
                  <Form.Control
                    onChange={this.handlePercentageCapChange}
                    value={data.percentageCap}
                    type="number"
                  />
                </Form.Group>
              </>
            )}
          </fieldset>
          {!data.numbers && (
            <Form.Group controlId="phoneNumbers">
              <Form.Check
                onChange={this.handlePhoneNumbersStatusChange}
                checked={data.numbers !== null}
                type="checkbox"
                label="Specify Phone Numbers"
              />
            </Form.Group>
          )}
          {data.numbers && (
            <fieldset>
              <legend>Phone Numbers</legend>
              <Form.Group controlId="phoneNumbers">
                <Form.Check
                  onChange={this.handlePhoneNumbersStatusChange}
                  checked={data.numbers !== null}
                  type="checkbox"
                  label="Specify Phone Numbers"
                />
              </Form.Group>
              {data.numbers.map((number, i) => (
                <>
                  <Form.Group controlId="numbers">
                    <InputGroup>
                      <Form.Control
                        value={number}
                        onChange={this.handleChangeNumbers(i)}
                        type="number"
                      />
                      <InputGroup.Append>
                        <Button variant="danger" onClick={this.deleteNumber(i)}>
                          Delete
                        </Button>
                      </InputGroup.Append>
                    </InputGroup>
                    <Form.Text className={"error-label"}>
                      {error.numbers[i]}
                    </Form.Text>
                  </Form.Group>
                </>
              ))}
              <Button onClick={this.addNumber} variant="primary">
                Add
              </Button>
            </fieldset>
          )}
          <Form.Group controlId="limit">
            <Form.Label>Usage Limit</Form.Label>
            <Form.Control
              onChange={this.handleLimitChange}
              value={data.limit}
              type="number"
            />
          </Form.Group>
          <Form.Group>
            <Form.Check
              onChange={this.handleActiveChange}
              checked={data.active}
              type="checkbox"
              label="Active"
            />
          </Form.Group>
          <Form.Group>
            <Form.Check
              onChange={this.handleCarePortalEnabledChange}
              checked={data.care_portal_enabled}
              type="checkbox"
              label="Care portal enabled"
            />
          </Form.Group>

          <Form.Group>
            <Form.Check
              onChange={this.handleVisibleOnAndroid}
              checked={data.visible_on_android}
              type="checkbox"
              label=" Visible on Android"
            />
          </Form.Group>

          <Form.Group>
            <Form.Check
              onChange={this.handleCustomerDelight}
              checked={data.customer_delight}
              type="checkbox"
              label="Customer Delight"
            />
          </Form.Group>
          <Form.Group>
            <Form.Check
              onChange={this.handleAndroidRenewal}
              checked={data.android_renewal}
              type="checkbox"
              label="Android - Renewal Card"
            />
          </Form.Group>
          <Button
            disabled={isSubmitting || hasErrors}
            className="submit-button"
            variant="primary"
            type="submit"
          >
            Submit
          </Button>
        </Form>
      </div>
    );
  }
}

export default withRouter(DicountCouponListComponent);
